import { put } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, country) => {
    return await put(`/basket/${basketId}/countries/${country}`, {});
};
